import { render, staticRenderFns } from "./ReceiveTel.vue?vue&type=template&id=7053541a&scoped=true"
import script from "./ReceiveTel.vue?vue&type=script&lang=js"
export * from "./ReceiveTel.vue?vue&type=script&lang=js"
import style0 from "./ReceiveTel.vue?vue&type=style&index=0&id=7053541a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053541a",
  null
  
)

export default component.exports